<template>

  <b-modal 
    v-model="isVisibleLocal" 
    hide-footer
    static
  >
    <b-card class="text-center">
      <h2>Agregar Firma</h2>
      <canvas ref="signatureCanvas" id="signatureCanvas" width="400" height="150" class="signature-canvas my-2"></canvas>

      <b-button
        v-if="!isRecording" 
        variant="success" 
        @click="startCapture"
        class="mx-1"
      >
        Comenzar Captura
      </b-button>

      <b-button
        v-if="isRecording"
        variant="warning" 
        @click="stopCapture"
      >
        Finalizar Captura
      </b-button>

      <b-button
        v-if="!isRecording"
        variant="danger"  
        @click="clearSignature"
        class="mx-1"
      >
        Borrar Captura
      </b-button>


    </b-card>
  </b-modal>
  
</template>

<script>
export default {
  name: "TopazSignature",

  props: {

    value: {
      type: String,
      default: null
    },

    isVisible: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isVisibleLocal: false,
      isRecording : false,
      signature   : null
    }
  },

  methods: {

    onHidden() {
      this.isVisible = false
    },

    startCapture() {
      if (typeof window.SetTabletState === 'function') {
        this.isRecording = true;

        this.clearSignature();
        const canvas = this.$refs.signatureCanvas;
        const ctx = canvas.getContext("2d");
        this.captureInterval = window.SetTabletState(1, ctx); 
        // window.SetTabletState(1, ctx); // Activa la captura
      } else {
        console.error("La función SetTabletState no está disponible.");
      }
    },

    stopCapture() {
      if (typeof window.SetTabletState === "function") {
        this.isRecording = false;

        window.SetTabletState(0);

        // Limpia el intervalo para detener las solicitudes
        if (this.captureInterval) {
          clearInterval(this.captureInterval);
          this.captureInterval = null;
        }
      }

      this.saveSignature();
    },

    clearSignature() {
      const canvas = this.$refs.signatureCanvas;
      const ctx = canvas.getContext("2d");
      if (typeof window.ClearTablet === "function") {
        window.ClearTablet(); // Limpia la firma del dispositivo
      } else {
        console.warn("La función ClearTablet no está disponible.");
      }
      // Limpia también el canvas
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      this.signature = null;
      this.$emit('input', null);
    },


    isCanvasEmpty() {
      const canvas = this.$refs.signatureCanvas;
      const ctx = canvas.getContext("2d");

      // Obtener los datos de los píxeles en el canvas
      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const data = imageData.data;

      // Iterar sobre los píxeles
      for (let i = 0; i < data.length; i += 4) {
        // Comprobar si el píxel es transparente (RGBA: 0, 0, 0, 0)
        if (data[i + 3] !== 0) {
          // Si hay algún píxel que no es transparente, el canvas no está vacío
          return false;
        }
      }

      // Si todos los píxeles son transparentes, el canvas está vacío
      return true;
    },

    saveSignature() {

      if (this.isCanvasEmpty()) {
        console.error("El canvas está vacío. No se puede guardar la firma.");
        this.$emit('input', null);
        return;
      }
      
      const canvas = this.$refs.signatureCanvas;
      const b64Image = canvas.toDataURL("image/png").split(",")[1];
      this.signature = b64Image;
      this.$emit('input', b64Image);
    },
  },

  watch: {


    signature(newValue) {
      this.$store.commit('setPacienteSignature', newValue);
      this.$emit('signatureBlob', newValue);
    }, 

    isVisible(val) {
      this.isVisibleLocal = val;
    },

    isVisibleLocal(newValue) {
      this.$emit('update:isVisible', newValue);
    },
  }
};
</script>

<style scoped>
  .signature-canvas {
    border: 1px solid #ccc;
  }
</style>